import React from 'react';

const Footer = () => {
    return (
        <div align="center" className="mt-5">
            <p>All rights reserved by <span style={{color: '#64ffda'}}>SHOZON RAJ</span> </p>
        </div>
    );
};

export default Footer;